<template>
  <div>
    <div class="content_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          ><a @click="$router.back(-1)">{{ name }}</a></el-breadcrumb-item
        >
        <el-breadcrumb-item> 批次运单明细 </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content_box padding">
        <div class="content_box_title">
          <div class="circle_l"></div>
          <div class="circle_r"></div>
          <div class="text_xl">筛选查询</div>
        </div>
        <!-- 搜索筛选 -->
        <div>
          <div class="table_item_box">
            <div class="table_item_box_l">
              <div class="table_item_box_l_r">
                <div class="fill_in_title">运单号</div>

                <input
                  v-model="screen.ordernumber"
                  type="text"
                  placeholder="请输入运单号"
                  class="table_item_input"
                />
              </div>
              <div class="table_item_box_l_r">
                <div class="fill_in_title">批次号</div>

                <input
                  v-model="screen.batchname"
                  type="text"
                  placeholder="请输入批次号"
                  class="table_item_input"
                />
              </div>
            </div>
            <div class="table_item_box_l">
              <div class="table_item_box_l_r">
                <div class="fill_in_title">国内单号</div>

                <input
                  v-model="screen.domesticnumber"
                  type="text"
                  placeholder="请输入国内单号"
                  class="table_item_input"
                />
              </div>
              <div class="table_item_box_l_r">
                <div class="fill_in_title">收件人</div>

                <input
                  v-model="screen.recipientname"
                  type="text"
                  placeholder="请输入收件人"
                  class="table_item_input"
                />
              </div>
            </div>
            <div class="table_item_box_l">
              <div class="table_item_box_l_r">
                <div class="fill_in_title">国际段运单号</div>

                <input
                  v-model="screen.secondtracknumber"
                  type="text"
                  placeholder="请输入国际段运单号"
                  class="table_item_input"
                />
              </div>
              <div class="table_item_box_l_r">
                <div class="fill_in_title">选择线路</div>
                <el-select
                  clearable
                  class="table_item_input"
                  v-model="screen.routeid"
                  placeholder="请选择选择线路"
                >
                  <el-option
                    v-for="(item, index) in circuitData"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <!-- <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">选择线路</div>
              <el-select
                class="input_select"
                v-model="screen.routeid"
                placeholder="请选择国内快递公司"
              >
                <el-option
                  v-for="item in circuitData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div> -->
            <div
              class="table_item_box_s"
              style="flex-direction: column-reverse"
            >
              <div class="table_item_box_l_r"></div>
              <div class="table_item_box_l_s">
                <el-button type="primary" @click="search" round>搜索</el-button>
                <el-button @click="reset" round>重置</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content_box">
      <div class="content_box_ls">
        <div class="content_box_title">
          <div class="circle_l"></div>
          <div class="circle_r"></div>
          <div class="text_xl">批次号：{{ title }}运单明细</div>
        </div>
        <div class="content_box_title_r">
          <div class="text_l">总重量 {{ weightkgTal.toFixed(2) }}</div>
          <div class="text_l">包裹数 {{ number }}</div>
          <div class="text_l">总运费 {{ shippingcostTal.toFixed(2) }}</div>
        </div>
      </div>

      <div class="table_box">
        <el-table
          v-loading="tableLoading"
          :header-cell-style="{ background: '#E7EDF8', color: '#333333' }"
          :data="orderData.content"
          stripe
          style="width: 100%"
        >
          <el-table-column align="center" prop="datecreated" label="创建日期">
          </el-table-column>
          <el-table-column align="center" prop="ordernumber" label="单号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="domesticnumber"
            label="国内单号"
          >
          </el-table-column>
             <el-table-column
            align="center"
            prop="secondtracknumber"
            label="国际单号"
          >
          </el-table-column>
         <el-table-column align="center" prop="recipientname" label="收件人">
          </el-table-column>
          <el-table-column align="center" prop="itemNames" label="包裹内件">
          </el-table-column>
                 <el-table-column align="center" prop="shippingcost" label="总运费">
          </el-table-column>
          <el-table-column align="center" prop="stateValue" label="包裹状态">
            <template slot-scope="scope">{{scope.row.stateValue}} </template>
          </el-table-column>
          <el-table-column align="center" prop="status" label="最新状态">
            <template slot-scope="scope">
              {{ scope.row.status ? scope.row.status : "-" }}
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" prop="weightkg" label="收费重量">
          </el-table-column> -->
   
          <!-- <el-table-column align="center" prop="baggagenum" label="总箱数">
          </el-table-column> -->
  <el-table-column align="center" prop="pickUpLocationName" label="取货点">
          </el-table-column>
          <el-table-column align="center" label="详情">
            <template slot-scope="scope">
              <el-button type="text" @click="logistics(scope.row)"
                >查看物流</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="paging_box">
          <el-pagination
            @current-change="pageChange"
            background
            layout="prev, pager, next"
            :total="orderData.totalElements"
          >
          </el-pagination>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import crudDept from "@/api/userMG";
export default {
  data() {
    return {
         orderState: [
        { name: "未匹配", id: 0 },
        { name: "未入库", id: 1 },
        { name: "已入库", id: 5 },
        { name: "待发货", id: 10 },
        { name: "已发货", id: 20 },
        { name: "已到货", id: 26 },
        { name: "待提货", id: 30 },
        { name: "正在派送", id: 35 },
        { name: "已派送", id: 40 },
        { name: "待确认", id: 60 },
        { name: "已确认", id: 65 },
        { name: "待退运", id: 70 },
        { name: "已退运", id: 75 },
        { name: "违禁品", id: 80 },
        { name: "历史包裹", id: 100 },
      ],
      tableLoading: "",
      name: "",
      title: "",
      orderData: [],
      //  transfernumber: "",
      screen: {
        page: 1,
        size: 1000,

        ordernumber: "",
        batchId: "",
        secondtracknumber: "",
        routeid: "",
        recipientname: "",
        batchname: "",
        grouptype: "",
        state: "",
        queryType: 1,
      },
      batchId: "",
      batch: "",
      circuitData: [],
      shippingcostTal: 0,
      weightkgTal: 0,
      number: 0,
    };
  },
  created() {
    this.batch = JSON.parse(localStorage.getItem("batch"));
    this.batchId = this.$route.query.id;
    this.screen.batchId = this.$route.query.id;
    this.screen.queryType=this.$route.query.queryType ? this.$route.query.queryType : 1;
    // this.screen.grouptype=this.$route.query.grouptype ? this.$route.query.grouptype :'';
    this.screen.state = this.$route.query.state ? this.$route.query.state : "";
    this.title = this.$route.query.title;

    this.name = this.$route.query.name;
    //console.log(this.name)
    this.orderList();
    this.circuit();
  },
  methods: {
    // 线路
    circuit() {
      var data = {
        page: 1,
        size: 100,
      };
      crudDept.circuit(data).then((res) => {
        this.circuitData = res.content;
        res.content.map((item) => {
          item.value = item.id;
          item.label = item.name;
        });
        this.circuitData = res.content;
        //console.log(this.circuitData);
      });
    },
    logistics(item) {
      localStorage.setItem("order", JSON.stringify(item));
      this.$router.push({
        path:
          "/logistics/logistics?code=" +
          item.domesticcarrier +
          "&num=" +
          item.domesticnumber,
      });
    },
    reset() {
      this.screen = {
        page: 1,
        size: 1000,
        ordernumber: "",
        batchId: this.batchId,
        secondtracknumber: "",
        routeid: "",
        recipientname: "",
        batchname: "",
        grouptype: "",
        state: "",
      };
      this.orderList();
    },
    //搜索
    search() {
      this.orderList();
    },
    //分页
    pageChange(e) {
      //console.log(e);
      this.screen.page = e;
      //console.log(this.screen);
      this.orderList();
    },
    //订单列表
    orderList() {
      this.tableLoading = true;
      crudDept
        .orderList(this.screen)
        .then((res) => {
          this.orderData = res;
          this.number = res.content.length;
          if (res.content.length > 0) {
            res.content.forEach((element) => {
                const matched = this.orderState.find(({ id }) => id == element.state);
            // item.itemNames=item.itemNames.toString()
            if (matched) {
              element.stateValue = matched.name;
            }
              this.shippingcostTal += element.shippingcost * 1;
              this.weightkgTal += element.weightkg * 1;
            });
          }

          this.tableLoading = false;
        })
        .catch((res) => {
          this.tableLoading = false;
        });
    },
  },
};
</script>
<style scoped>
.content_box {
  width: 100%;
  height: auto;
  background: #ffffff;
  padding: 38px 30px;
  margin-bottom: 12px;
  box-sizing: border-box;
}
.content_box_title_r {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.content_box_ls {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.padding {
  padding: 38px 0 !important;
}
.table_item_box_l_s .el-button.is-round {
  border-radius: 14px;
  width: 110px;
  height: 40px;
}
.table_item_box_s {
  display: flex;
}
.table_item_box_l_s {
  display: flex;
}
.table_item_input >>> .el-input__inner {
  background: none !important;
  outline: none !important;

  border: none;
  padding: 0;
}
.fill_in_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-right: 9px;
}
.table_item_box {
  display: flex;
  /* align-items: flex-end; */

  flex-wrap: wrap;
  padding: 25px 30px 0;
  box-sizing: border-box;
}
.table_item_box_l_r {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}
.table_item_input {
  width: 180px;
  height: 40px;
  background: #ffffff;

  border: 1px solid #dedede;
  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.table_item_box_l {
  margin-right: 30px;
  text-align: left;
}
.text_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 21px;
  color: #333333;
  margin-left: 45px;
}
.table_box {
  margin-top: 32px;
}
</style>


// WEBPACK FOOTER //
// src/views/extractGoods/details.vue